const legacyStorageKey = (drawingId) => `promang.drawings.pendingPins.${drawingId}`;
const storageKey = (drawingId, versionKey = "live") =>
  `promang.drawings.pendingPins.${drawingId}.${versionKey || "live"}`;

export const loadPendingPins = (drawingId, versionId = null) => {
  if (!drawingId || typeof window === "undefined") return [];
  try {
    const versionKey = versionId || "live";
    // Preferred: version-scoped key
    let raw = window.localStorage.getItem(storageKey(drawingId, versionKey));
    // Migration fallback: if loading LIVE and only legacy key exists, migrate it once.
    if (!raw && versionKey === "live") {
      const legacyRaw = window.localStorage.getItem(legacyStorageKey(drawingId));
      if (legacyRaw) {
        // Migrate legacy → versioned (assume legacy entries belong to LIVE)
        window.localStorage.setItem(
          storageKey(drawingId, "live"),
          legacyRaw
        );
        window.localStorage.removeItem(legacyStorageKey(drawingId));
        raw = legacyRaw;
      }
    }
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const savePendingPins = (drawingId, pins, versionId = null) => {
  if (!drawingId || typeof window === "undefined") return;
  try {
    const versionKey = versionId || "live";
    if (!pins?.length || pins.length === 0) {
      window.localStorage.removeItem(storageKey(drawingId, versionKey));
      // Also clear any legacy key when saving LIVE to avoid stale reloads.
      if (versionKey === "live") {
        window.localStorage.removeItem(legacyStorageKey(drawingId));
      }
      return;
    }
    // Never persist File/Blob — only serializable payload + pin geometry.
    const safe = pins.map((pin) => ({
      ...pin,
      payload: pin.payload
        ? {
            ...pin.payload,
            photoFile: undefined,
            sketchStrokes: pin.payload.sketchStrokes || null,
          }
        : null,
    }));
    window.localStorage.setItem(
      storageKey(drawingId, versionKey),
      JSON.stringify(safe)
    );
    // Ensure legacy key is cleared for LIVE after a successful write.
    if (versionKey === "live") {
      window.localStorage.removeItem(legacyStorageKey(drawingId));
    }
  } catch (err) {
    console.warn("Could not persist pending drawing pins:", err);
  }
};

export const makeLocalPinId = () =>
  `local-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
